import * as Analytics from './Analytics';
import { AriaDatapoint } from './datapoints/AriaDatapoint';
import registerServiceActionAnalytics from './registerServiceActionAnalytics';
import { AnalyticsOptions } from './types/DatapointEnums';
import { DatapointOptions } from 'owa-analytics-actions';
import { LazyAction, LazyModule } from 'owa-bundling';
import { getNonBootUserConfiguration } from 'owa-nonboot-userconfiguration-manager';
import { registerTracerListener, TraceLevel } from 'owa-trace';
export { AriaDatapoint, DatapointOptions };

const lazyAnalytics = new LazyModule(() =>
    import(/* webpackChunkName: "Analytics", webpackPrefetch: true */ './Analytics')
);

const lazyLogErrorDatapoint = new LazyAction(lazyAnalytics, m => m.logErrorDatapoint);

let delayedAnalytics: typeof Analytics;
export async function lazyInitializeAnalytics(
    analyticsOptions: AnalyticsOptions,
    featureFlags: string[]
) {
    // if no aria tokens are passed in, there is no point
    if (
        analyticsOptions.ariaTenantTokens &&
        (analyticsOptions.ariaTenantTokens.length > 0 ||
            typeof analyticsOptions.ariaTenantTokens == 'function')
    ) {
        registerTracerListener((message, traceLevel, errorDetails) => {
            if (traceLevel == TraceLevel.Error) {
                lazyLogErrorDatapoint.importAndExecute(errorDetails).catch(() => {
                    // Catch errors so we don't end up in an infinite loop
                });
            }
        });
        registerServiceActionAnalytics();

        let nonBootProimse = getNonBootUserConfiguration();
        delayedAnalytics = await lazyAnalytics.import();
        delayedAnalytics.initializeAnalytics(analyticsOptions, featureFlags, nonBootProimse);
    }
}

export function getSessionId(): string {
    if (delayedAnalytics) {
        return delayedAnalytics.getSessionId();
    }
    return null;
}

export let lazyFlush = new LazyAction(lazyAnalytics, m => m.flush);
export let lazyLogDatapoint = new LazyAction(lazyAnalytics, m => m.logDatapoint);
export let lazyCaptureServiceActionOptics = new LazyAction(
    lazyAnalytics,
    m => m.captureServiceActionOptics
);
export let lazyLogPLTDatapoint = new LazyAction(lazyAnalytics, m => m.logPLTDatapoint);
export let lazyGetResourceTimingForUrl = new LazyAction(
    lazyAnalytics,
    m => m.getResourceTimingForUrl
);
export let lazyLogSigsDatapoint = new LazyAction(lazyAnalytics, m => m.logSigsDatapoint);

export let lazyLogCLPAriaDataPoint = new LazyAction(lazyAnalytics, m => m.logCLPAriaDataPoint);

export function lazyGetOTelAddinsLogger(tenantToken: string) {
    return lazyAnalytics.import().then(analytics => analytics.getOTelAddinsLogger(tenantToken));
}
